import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Date")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Content")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("col", { class: "dateCol" }, null, -1)
const _hoisted_4 = { style: {"width":"50%"} }
const _hoisted_5 = {
  colspan: "8",
  class: "table-example--pagination"
}

import { computed, ref } from "vue";
import { Protocol } from "@/models/Protocol";
import { AlertHistory } from "@/models/AlertHistory";
import Moralis from "moralis";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
  protocol: { type: Protocol, required: true },
},
  async setup(__props) {

let __temp: any, __restore: any

const props = __props



const sortBy = ref("shortDateTime");
const sortingOrder = ref<"asc" | "desc">("desc");
const total = ref(0);
const page = ref(1);
const pageSize = ref(15);

const currentPage = computed({
  get(): number {
    return page.value;
  },
  set(p: number) {
    page.value = p;
    refresh();
  },
});

const alertColumns = ref([
  { key: "shortDateTime", label: "Date", sortable: true },
  { key: "status", label: "Status", sortable: true },
  { key: "subscriptionTypeName", label: "Type", sortable: true },
  { key: "content", label: "Content", sortable: true },
]);

const alerts = ref<AlertHistory[]>([]);
const query = new Moralis.Query(AlertHistory);
if (props.protocol) {
  query.equalTo("Protocol", props.protocol);
}

const refresh = async (): Promise<void> => {
  total.value = await query.count();
  query.limit(pageSize.value);
  query.skip(currentPage.value);
  const newAlerts = await query.find();
  alerts.value.length = 0;
  alerts.value.push(...newAlerts);
};
const subscription = (
  ([__temp,__restore] = _withAsyncContext(() => query.subscribe())),
  __temp = await __temp,
  __restore(),
  __temp
);

subscription.on("create", (a: AlertHistory) => {
  alerts.value.push(a);
});
// eslint-disable-next-line @typescript-eslint/no-unused-vars
subscription.on("update", (a: AlertHistory) => {
  const index = alerts.value.findIndex((e) => e.id == a.id);
  if (index > -1) {
    alerts.value.splice(index, 1, a);
  }
});
subscription.on("enter", (a: AlertHistory) => {
  alerts.value.push(a);
});
subscription.on("leave", (a: AlertHistory) => {
  const index = alerts.value.findIndex((e) => e.id == a.id);
  if (index > -1) {
    alerts.value.splice(index, 1);
  }
});
subscription.on("delete", (a: AlertHistory) => {
  const index = alerts.value.findIndex((e) => e.id == a.id);
  if (index > -1) {
    alerts.value.splice(index, 1);
  }
});
;(
  ([__temp,__restore] = _withAsyncContext(() => refresh())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  const _component_va_pagination = _resolveComponent("va-pagination")!
  const _component_va_data_table = _resolveComponent("va-data-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_va_data_table, {
      items: alerts.value,
      "sort-by": sortBy.value,
      "onUpdate:sort-by": _cache[1] || (_cache[1] = ($event: any) => ((sortBy).value = $event)),
      "sorting-order": sortingOrder.value,
      "onUpdate:sorting-order": _cache[2] || (_cache[2] = ($event: any) => ((sortingOrder).value = $event)),
      striped: "",
      columns: alertColumns.value
    }, {
      "header(shortDateTime)": _withCtx(() => [
        _hoisted_1
      ]),
      "header(content)": _withCtx(() => [
        _hoisted_2
      ]),
      "cell(shortDateTime)": _withCtx(({ source: shortDateTime }) => [
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(shortDateTime), 1)
      ]),
      "cell(type)": _withCtx(({ source: type }) => [
        _createTextVNode(_toDisplayString(type), 1)
      ]),
      "cell(content)": _withCtx(({ source: content }) => [
        _createElementVNode("div", _hoisted_4, _toDisplayString(content), 1)
      ]),
      bodyAppend: _withCtx(() => [
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_5, [
            _createVNode(_component_va_pagination, {
              modelValue: _unref(currentPage),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(currentPage) ? (currentPage).value = $event : null)),
              input: "",
              "hide-on-single-page": "",
              total: total.value,
              "page-size": pageSize.value
            }, null, 8, ["modelValue", "total", "page-size"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["items", "sort-by", "sorting-order", "columns"])
  ]))
}
}

})